import React from 'react'
import { BreadcrumbView } from '../../../../../../context/breadcrumb.context'
import { useParamsInt } from '../../../../../../shared/hooks/location'
import { Menu, MenuDelete, MenuItem } from '../../../../../../shared/menu/menu'
import { IconCheck, IconDownload, IconEdit } from '../../../../../../shared/icon/icon'
import { CardFullHeightScrollY } from '../../../../../../shared/card/card-full-height-scroll-y'
import { useRoleSysApp } from '../../../../../../role/hook/role-sys'
import { useApiFormAppBuildVersion } from '../../../../../../api-new/state/config'
import { FormSimple } from '../../../../../../shared/form-simple/form'
import { FormSimpleText } from '../../../../../../shared/form-simple/form-text'
import { ButtonSubmit } from '../../../../../../shared/form-simple/form-submit'
import { FormSimpleDateFormat } from '../../../../../../shared/form-simple/form-data-format'
import { FormSimpleNumber } from '../../../../../../shared/form-simple/form-number'
import { FormSimpleSelectBool } from '../../../../../../shared/form-simple/form-select-bool'
import { FormSimpleTextarea } from '../../../../../../shared/form-simple/form-textarea'
import { useDownloadPresign } from '../../../../../../shared/download/hook'
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min'

export const AppBuildVersionEdit = () => {
  const { appID, appStoreID, appVersionID, appBuildVersionID } = useParamsInt()

  const history = useHistory()

  const apiFormAppBuildVersion = useApiFormAppBuildVersion()

  const roleSysApp = useRoleSysApp()

  const { active, download } = useDownloadPresign()

  const handlePath = () => apiFormAppBuildVersion.get(`${appBuildVersionID}/item`)

  const handleSetCurrent = async id => {
    await apiFormAppBuildVersion.put(`${id}/current`)
    await apiFormAppBuildVersion.get(`${appBuildVersionID}/item`)
  }

  const handleDownload = async id => {
    let presigned = await apiFormAppBuildVersion.get(`${id}/presigned-download`)
    download(presigned.url)
  }

  const handleDelete = async id => {
    await apiFormAppBuildVersion.delete(id)
    history.replace(`/admin/app/edit/${appID}/store/edit/${appStoreID}/version/edit/${appVersionID}/version`)
  }

  const handleSubmit = async data => {
    await apiFormAppBuildVersion.put(data.id, data)
  }

  const HeaderMenu = () =>
    <Menu>
      <MenuItem Icon={IconCheck} text="set current" onClick={() => handleSetCurrent(appBuildVersionID)} show={roleSysApp.accessUpdate} />
      <MenuItem Icon={IconDownload} text="download" onClick={() => handleDownload(appBuildVersionID)} show={roleSysApp.accessRead} disabled={active} />
      <MenuDelete onClick={() => handleDelete(appBuildVersionID)} show={roleSysApp.accessDelete} />
    </Menu>

  return (
    <React.Fragment>
      <BreadcrumbView Icon={IconEdit} text={apiFormAppBuildVersion.form.filename} onPath={handlePath}>
        <CardFullHeightScrollY title={apiFormAppBuildVersion.form.filename} HeaderMenu={HeaderMenu}>
          <FormSimple state={apiFormAppBuildVersion.form} onSubmit={handleSubmit} onRefresh={handlePath}>
            <FormSimpleDateFormat label="created" name="createdAt" />
            <FormSimpleDateFormat label="updated" name="updatedAt" />
            <FormSimpleText label="storageKey" name="storageKey" readonly />
            <FormSimpleNumber label="content length" name="contentLength" readonly />
            <FormSimpleSelectBool label="isCurrent" name="isCurrent" readonly />
            <FormSimpleText label="uploaded by" name="uploadedBy" readonly />
            <FormSimpleText label="filename" name="filename" />
            <FormSimpleTextarea label="notes" name="note" />
            <ButtonSubmit text="save version" />
          </FormSimple>
        </CardFullHeightScrollY>
      </BreadcrumbView>
    </React.Fragment>
  )
}
